import ClientInfoBlock from './ClientInfoBlock';

export default ClientInfoBlock;
